<template lang="pug">
  picture
    source(
      v-for="derivative in derivativesSources"
      :key="derivative.url"
      :srcset="derivative.url+' 1x'"
      :media="derivative.size ? '(min-width: '+derivative.size+')' : null"
    )
    img(
      :src="defaultSource"
      :class="fit ? 'fit' : null"
      :alt="name"
      :title="name"
    )

</template>

<script>
export default {
  props: ['derivatives', 'type', 'fit', 'name'],
  data () {
    return {
      defaultSource:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTFDRUFDNzk4QkFGMTFFQUFCMTFFNzhCNzI4NjM0NUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTFDRUFDN0E4QkFGMTFFQUFCMTFFNzhCNzI4NjM0NUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5MUNFQUM3NzhCQUYxMUVBQUIxMUU3OEI3Mjg2MzQ1QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5MUNFQUM3ODhCQUYxMUVBQUIxMUU3OEI3Mjg2MzQ1QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtfcwCcAAAAVSURBVHjaYvz//z8DCDAxQAFAgAEAMAYDAajvwn8AAAAASUVORK5CYII=',
      derivativesSources: []
    }
  },
  mounted: function () {
    if (this.derivatives) {
      this.setAdapatativeImg()
    }
  },
  methods: {
    setAdapatativeImg: function () {
      switch (this.type) {
        case 'block':
          if (this.derivatives.picture_block_desktop) {
            this.defaultSource = this.derivatives.picture_block_desktop.href
            this.derivativesSources = [
              {url: this.derivatives.picture_block_desktop.href, size: null},
              {url: this.derivatives.picture_block_mobile.href, size: 640}
            ]
          }
          break
        case 'cover':
          if (this.derivatives.picture_cover_desktop_large) {
            this.defaultSource = this.derivatives.picture_cover_desktop_large.href
            this.derivativesSources = [
              {url: this.derivatives.picture_cover_desktop_large.href, size: null},
              {url: this.derivatives.picture_cover_desktop.href, size: 1440},
              {url: this.derivatives.picture_cover_tablet.href, size: 960},
              {url: this.derivatives.picture_cover_mobile.href, size: 640}
            ]
          }
          break
        default:
          this.derivativesSources = null
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

  img
    width 100%

  .fit
    object-fit cover
    width 100%
    height 100%

</style>
